export default __webpack_public_path__ + "static/media/welcome.bbcc0f13.png";